<template>
  <div class="page_box home_page">
    <dv-border-box-11 title="基本信息" class="school_info_box">
      <div class="info_row_box">
        <div class="info_item_box">
          <span>机构名称:</span>
          <div>{{ schoolInfo.schoolName }}</div>
          <!-- <dv-decoration-8 style="width:300px;height:50px;margin-top:-45px" /> -->
          <dv-decoration-2 class="info_item_hr" />
        </div>
        <div class="info_item_box">
          <span>机构代码:</span>
          <div>{{ schoolInfo.schoolInstitutionCode }}</div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
      </div>
      <div class="info_row_box">
        <div class="info_item_box">
          <span>创办时间:</span>
          <div>{{ $Common.timeStampToDate(schoolInfo.establishmentTime) }}</div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
        <div class="info_item_box">
          <span>建筑面积:</span>
          <div>{{ schoolInfo.schoolFloorSpace }}㎡</div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
      </div>
      <div class="info_row_box">
        <div class="info_item_box">
          <span>校长:</span>
          <div>{{ schoolInfo.schoolPrincipal }}</div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
        <div class="info_item_box">
          <span>副校长:</span>
          <div>{{ schoolInfo.vicePrincipal }}</div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
      </div>
      <div class="info_row_box">
        <div class="info_item_box">
          <span>学校类别:</span>
          <div>
            {{ $Common.getDataName(schoolCategory, schoolInfo.schoolCategory) }}
          </div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
        <div class="info_item_box">
          <span>办学类别:</span>
          <div>
            {{ $Common.getDataName(schoolType, schoolInfo.workCategory) }}
          </div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
      </div>
      <div class="info_row_box">
        <div class="info_item_box">
          <span>教职工人数:</span>
          <div>{{ schoolInfo.numberFaculty }}人</div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
        <div class="info_item_box">
          <span>学生人数:</span>
          <div>{{ schoolInfo.numberStudents }}人</div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
      </div>
      <div class="info_row_box">
        <div class="info_item_box">
          <span>学校地址:</span>
          <div>{{ schoolInfo.schoolAddress }}</div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
        <div class="info_item_box">
          <span>校方联系方式:</span>
          <div>{{ schoolInfo.vicePrincipalContactWay }}</div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
      </div>
      <div class="info_row_box" style="height:113px">
        <div class="info_item_box">
          <span>Logo:</span>
          <div style="height:90px">
            <el-image
              style="width:78px;height:78px"
              :preview-src-list="[
                $store.state.config.fileUrl + schoolInfo.logUrl
              ]"
              :src="$store.state.config.fileUrl + schoolInfo.logUrl"
            >
            </el-image>
          </div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
        <div class="info_item_box">
          <span>安全信息公示二维码:</span>
          <div style="height:90px">
            <el-image
              :preview-src-list="[
                $store.state.config.fileUrl +
                  schoolInfo.securityInformationCodeUrl
              ]"
              style="width:78px;height:78px"
              :src="
                $store.state.config.fileUrl +
                  schoolInfo.securityInformationCodeUrl
              "
            >
            </el-image>
          </div>
          <dv-decoration-2 class="info_item_hr" />
        </div>
      </div>
    </dv-border-box-11>
    <div class="right_box">
      <dv-border-box-8 class="school_big_box">
        <h2 class="school_big_box" @click="pushBigData">
          <span v-for="(item, index) in title" :key="index">{{ item }}</span>
        </h2>
      </dv-border-box-8>
      <div class="backlog_title">待办事项</div>
      <dv-decoration-5 class="backlog_title_bg" />
      <div class="backlog_title_list_box">
        <vueSeamlessScroll
          v-if="tableData.length > 0"
          :data="tableData"
          :class-option="defaultOption"
          class="seamless-warp"
        >
          <div
            class="list"
            v-for="(item, index) in tableData"
            :key="index"
            @click="checkInfo(item.id)"
          >
            <div class="li" :id="item.id">
              {{ item.noticeDescription }}
            </div>
            <div class="sel">
              <div>
                {{ $Common.timeStampToDate(item.reportingTime * 1000) }}
              </div>
              <a href="javascript:;" :id="item.id" @click="checkInfo(item.id)"
                >查看详情</a
              >
            </div>
          </div>
        </vueSeamlessScroll>
        <div v-else class="no-data">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    vueSeamlessScroll
  },
  props: {},
  data() {
    //这里存放数据
    return {
      requestData: {
        pageNum: 1,
        pageSize: 10000,
        recipientId: this.$store.getters.getUserInfo.userId,
        schoolId: this.$store.state.schoolId
      },
      tableData: [],
      schoolInfo: {
        schoolId: "",
        schoolName: "",
        schoolAddress: "",
        schoolCategory: "",
        schoolInstitutionCode: "",
        schoolFloorSpace: "",
        workCategory: "",
        numberFaculty: "",
        numberStudents: "",
        schoolPrincipal: "",
        establishmentTime: "",
        logUrl: "",
        vicePrincipal: "",
        vicePrincipalContactWay: "",
        securityInformationCodeUrl: ""
      },
      title: "校园安全风险防控平台"
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {
    schoolCategory() {
      return this.$store.state.select.schoolCategory;
    },
    schoolType() {
      return this.$store.state.select.schoolType;
    },
    defaultOption() {
      return {
        step: 0.3, //步长 越大滚动速度越快
        limitMoveNum: 3, //启动无缝滚动最小数据量 this.dataList.length
        hoverStop: true, //是否启用鼠标hover控制
        direction: 1, //1 往上 0 往下
        openWatch: true, //开启data实时监听
        singleHeight: 0, //单条数据高度有值hoverStop关闭
        waitTime: 1000 //单步停止等待时间
      };
    }
  },
  //方法集合
  methods: {
    async getBacklogList() {
      let res = await this.$Http.getHiddenDangerToList(this.requestData);
      if (res.code == 200) {
        this.tableData = res.data.list || [];
      } else if (res.code == 101) {
        this.tableData = [];
      } else {
        this.tableData = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取学校信息
    async getSchoolInfo() {
      var requestData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getSchoolInfo(requestData, true);
      if (res.code == 200) {
        this.schoolInfo.schoolId = res.data.schoolId;
        this.schoolInfo.establishmentTime = res.data.establishmentTime * 1000;
        this.schoolInfo.schoolAddress = res.data.schoolAddress;
        this.schoolInfo.schoolName = res.data.schoolName;
        this.schoolInfo.schoolCategory = res.data.schoolCategory;
        this.schoolInfo.schoolInstitutionCode = res.data.schoolInstitutionCode;
        this.schoolInfo.schoolFloorSpace = res.data.schoolFloorSpace;
        this.schoolInfo.workCategory = res.data.workCategory;
        this.schoolInfo.numberFaculty = res.data.numberFaculty;
        this.schoolInfo.numberStudents = res.data.numberStudents;
        this.schoolInfo.schoolPrincipal = res.data.schoolPrincipal;
        this.schoolInfo.logUrl = res.data.logUrl;
        this.schoolInfo.vicePrincipal = res.data.vicePrincipal;
        this.schoolInfo.vicePrincipalContactWay =
          res.data.vicePrincipalContactWay;
        this.schoolInfo.securityInformationCodeUrl =
          res.data.securityInformationCodeUrl;
        console.log(this.schoolInfo, "--------------");
        this.$store.commit("updateSchoolInfo", res.data);
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.msg,
          type: "error"
        });
      }
    },
    pushBigData() {
      let routeUrl = this.$router.resolve({
        path: "/safeposture_school"
      });
      window.open(routeUrl.href, "_blank");
    },
    async checkInfo(id) {
      let res = await this.$Http.updDangerTo({ id: id }, true);
      if (res.code == 200) {
        this.$Common.pageJump("/hidden_danger_data", "", 0);
        this.$store.commit("setSelect", false);
        this.$store.commit("updatePathIndex", "1-0-0");
      } else {
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    this.getSchoolInfo();
    this.getBacklogList();
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.home_page {
  display: flex;
}
.school_info_box {
  width: 40%;
  height: 100%;
  padding: 70px 25px 20px 25px;
}
.school_info_box /deep/ .border-box-content {
  overflow-y: scroll;
}
.info_row_box {
  width: 100%;
  padding: 0px 5px;
  height: 90px;
  display: flex;
  .info_item_box {
    width: 50%;
    height: 100%;
    span {
      height: 40px;
      width: 100%;
      font-size: 17px;
      color: #a5a5be;
      font-weight: 500;
    }
    div {
      height: 45.5px;
      width: 100%;
      font-size: 18px;
      color: #474859;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .info_item_hr {
      width: 100%;
      height: 0.5px;
      margin: 2px 0px;
    }
  }
}
.right_box {
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .school_big_box {
    width: 80%;
    height: 30%;
  }
  .school_big_box /deep/ .border-box-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
h2 {
  display: flex;
  justify-content: center;
  align-items: center;
}
h2 span {
  float: left;
  position: relative;
  font-size: 22px;
  color: rgb(170, 222, 252);
}

h2 span:nth-child(1) {
  -webkit-animation: jump 1.2s linear 0s infinite alternate;
}

h2 span:nth-child(2) {
  -webkit-animation: jump 1.2s linear 0.1s infinite alternate;
}

h2 span:nth-child(3) {
  -webkit-animation: jump 1.2s linear 0.2s infinite alternate;
}

h2 span:nth-child(4) {
  -webkit-animation: jump 1.2s linear 0.3s infinite alternate;
}

h2 span:nth-child(5) {
  -webkit-animation: jump 1.2s linear 0.4s infinite alternate;
}

h2 span:nth-child(6) {
  -webkit-animation: jump 1.2s linear 0.5s infinite alternate;
}

h2 span:nth-child(7) {
  -webkit-animation: jump 1.2s linear 0.6s infinite alternate;
}

h2 span:nth-child(8) {
  -webkit-animation: jump 1.2s linear 0.7s infinite alternate;
}

h2 span:nth-child(9) {
  -webkit-animation: jump 1.2s linear 0.8s infinite alternate;
}

h2 span:nth-child(10) {
  -webkit-animation: jump 1.2s linear 0.9s infinite alternate;
}

h2 span:nth-child(11) {
  -webkit-animation: jump 1.2s linear 1s infinite alternate;
}

h2 span:nth-child(12) {
  -webkit-animation: jump 1.2s linear 1.1s infinite alternate;
}

@-webkit-keyframes jump {
  0% {
    top: 0px;
  }
  50% {
    top: -4px;
  }
  100% {
    top: 4px;
  }
}
.backlog_title {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #474859;
  font-weight: 600;
}
.backlog_title_bg {
  width: 40%;
  height: 40px;
  margin-top: -30px;
}
.backlog_title_list_box {
  width: 80%;
  height: calc(70% - 70px);
  overflow-y: hidden;
  .list {
    width: 100%;
    text-align: left;
    margin-bottom: 16px;
    &:nth-child(3n-2) {
      .li {
        background: url("~@/assets/img/eduBigData/list-bg-1.png") center center
          no-repeat;
        background-size: 100% 100%;
      }
    }
    &:nth-child(3n-1) {
      .li {
        background: url("~@/assets/img/eduBigData/list-bg-2.png") center center
          no-repeat;
        background-size: 100% 100%;
      }
    }
    &:nth-child(3n) {
      .li {
        background: url("~@/assets/img/eduBigData/list-bg-3.png") center center
          no-repeat;
        background-size: 100% 100%;
      }
    }
    .li {
      width: 100%;
      padding: 6px 16px;
      text-align: left;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0e1038;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
      cursor: pointer;
    }
    .sel {
      display: flex;
      justify-content: space-between;
      line-height: 1;
      padding: 0 16px;
      margin-top: 8px;
      div {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0e1038;
        line-height: 12px;
      }
      a {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0e1038;
        line-height: 12px;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
  .no-data {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.backlog_title_list_box /deep/ .border-box-content {
  margin: 30px;
  height: calc(100% - 60px);
  width: calc(100% - 60px);
}
</style>
